import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useStore } from "../../js/state/store";
import { consumeBetaHandoff, stripBetaQuery } from "../../js/auth/betaOnboard";

export default function BetaHandoffHost() {
  const { dispatch } = useStore();
  const location = useLocation();
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    let cancelled = false;
    async function claim() {
      const params = new URLSearchParams(location.search);
      if (params.get("beta") !== "1") return;
      setBusy(true);
      try {
        const result = await consumeBetaHandoff(window.location);
        if (cancelled) return;
        if (result?.session) {
          dispatch({ type: "SET_SESSION", payload: result.session });
        }
      } catch {
        /* invalid or expired handoff — still clear the query */
      } finally {
        if (!cancelled) {
          stripBetaQuery(navigate);
          setBusy(false);
        }
      }
    }
    claim();
    return () => {
      cancelled = true;
    };
  }, [dispatch, location.search, navigate]);

  if (!busy) return null;
  return <p className="sr-only">Opening your Beta desk…</p>;
}
